var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AppFactory, render } from "..";
export function init(id = "opendash", factoryCallback) {
    return __awaiter(this, void 0, void 0, function* () {
        const factory = new AppFactory(id);
        yield Promise.resolve(factoryCallback(factory));
        const app = yield factory.createApp();
        // @ts-ignore
        window.app = app; // TODO: remove this line
        if (document.getElementById(id)) {
            render(app, document.getElementById(id));
        }
        else {
            document.addEventListener("DOMContentLoaded", () => {
                render(app, document.getElementById(id));
            });
        }
        return app;
    });
}
//# sourceMappingURL=init.js.map